import { useEffect } from 'react';
import queryString from '../../utils/queryString';
import { idFromPointer } from '../../utils/pointer';
import { Mode, ps5Mode } from '../../../common/types';
import usePromiseWithErrorHandling from '../../hooks/usePromiseWithErrorHandling';
import { useAnalytics } from '../../contexts/AnalyticsContext/useAnalytics';

/**
 * Only exported for tests
 */
export const getValidPlaystationDeeplink = (
  deeplink: string,
  setUtmParameters: (id: string) => void
): string | undefined => {
  const id = idFromPointer({ uri: deeplink });

  if (id) {
    setUtmParameters(id);
    return deeplink;
  }
};

const getLaunchParams = async () => {
  if (window.msdk?.device) {
    try {
      const result = await window.msdk?.device.getLaunchArgument();
      const launchParams = queryString.parse(result);
      const { uri } = launchParams;
      if (typeof uri === 'string') {
        return uri;
      }
    } catch (e) {
      const message = e instanceof Error ? e.message : e;
      window.elasticApm.captureError(
        new Error('PlaystationPreview: ' + message)
      );
    }
  }
};

export const usePlaystationPreview = (
  mode: Mode,
  setPlaystationRedirect: (deeplink: string) => void
) => {
  const { setUtmParameters } = useAnalytics();

  const setUtmParametersById = (id: string) =>
    setUtmParameters(mode, false, id);

  const { run: onLaunchArgument } = usePromiseWithErrorHandling(async () => {
    const deeplinkUnsafe = await getLaunchParams();
    if (deeplinkUnsafe) {
      const deeplinkValid = getValidPlaystationDeeplink(
        deeplinkUnsafe,
        setUtmParametersById
      );

      if (!deeplinkValid) {
        return;
      }
      setPlaystationRedirect(deeplinkValid);
    }
  });

  useEffect(() => {
    if (mode === ps5Mode) {
      onLaunchArgument();

      if (window.msdk) {
        window.msdk.addEventListener('onLaunchArgument', onLaunchArgument);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);
};
